(ns hai.tasks.add-pill
  "The tasks card's ＋ pill: the shared mini-app capsule
   ([[hai.mini-apps.add-pill]]) in two segments — ＋ New, and beside it the
   urgency a new task starts at, with a chevron opening the menu that changes
   it. The pick is kept on the user (`::data/set-default-urgency`), so the pill
   says where the task is going before the ＋ is pressed."
  (:require
   [hai.mini-apps.add-pill :as add-pill]
   [hai.tasks.data :as data]
   [hai.tasks.urgency :as urgency]
   [hai.tasks.urgency-menu :as urgency-menu]
   [hai.ui.components.tooltip :as tt]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def ^:private chevron-icon (icons/mui-icon :outlined :expand_more))

;; Outlined in the deeper sage the tasks page fills its Add task button with,
;; both halves the header's own tint and a hairline of the outline between
;; them, so the two read as one control with two jobs. Each half keeps its own
;; outer corners rather than the capsule clipping them, so the keyboard focus
;; ring the shared pill draws outside the half still shows. The halves and the
;; hairline stretch to the capsule's height rather than carrying one of their
;; own, so a host that makes it taller for touch resizes the whole control.
(o/defstyled pill add-pill/pill
  {:gap "0"
   :padding "0"
   :border-width "1px" :border-style "solid" :border-color t/--task-add-fill}
  [#{:.add-action :.add-menu :.add-divider}
   {:height "auto" :align-self "stretch"}]
  [:.add-action
   {:padding "0 12px 0 10px"
    :border-radius "999px 0 0 999px"}]
  [:.add-divider
   {:background t/--task-add-fill}]
  ;; The shared segment is an icon-only button, so it never set a font and
  ;; the browser's own button face showed through the label; give it ＋ New's.
  [:.add-menu
   {:width "auto"
    :gap "2px"
    :padding "0 6px 0 10px"
    :border-radius "0 999px 999px 0"
    :font-family "inherit"
    :font-size "13px" :font-weight "600" :line-height "1"
    :white-space "nowrap"}
   ;; The urgency labels differ in width, so the segment would resize as the
   ;; pick moves along them — and the header's actions would shuffle with it.
   ;; Hold it to the widest.
   [:span {:min-width "54px" :text-align "left"}]
   ;; Open, the segment keeps the wash hover gives it, so it reads as held.
   ["&[data-state='open']" {:background t/--note-kraft-10}]])

(defn component
  "The tasks header's ＋ pill. `on-add` opens the host's composer — which the
   host seeds at [[hai.tasks.data/default-urgency]], the urgency the second
   segment names. `container` is the element the menu portals into — the root
   the extension sidebar's portal-based UI shares
   ([[browser-ext.sidebar.shadow-root]]), as its other menus pass."
  [{:keys [on-add container]}]
  (let [default-urgency @(<s [::data/default-urgency])]
    [pill
     [tt/tooltip {:content "Add a task"}
      [:button.add-action
       {:type "button"
        :aria-label "Add a task"
        :on-click on-add}
       [icons/plus {:size 16}]
       [:span "New"]]]
     [:span.add-divider]
     [urgency-menu/component
      {:value default-urgency
       :on-change #(>e [::data/set-default-urgency %])
       :heading "New task goes in"
       :align "end"
       :container container}
      [:button.add-menu
       {:type "button"
        :aria-label (str "New task goes in " (urgency/label default-urgency) "; change")}
       [:span (urgency/label default-urgency)]
       [chevron-icon]]]]))
